/* UGC-video's op de productpagina: klik om met geluid af te spelen, andere video's pauzeren. */
(function () {
  if (window.lloUgcReady) return;
  window.lloUgcReady = true;

  function pauseOthers(current) {
    var vids = document.querySelectorAll('[data-llugc-card] video');
    for (var i = 0; i < vids.length; i++) {
      var o = vids[i];
      if (o !== current && !o.muted && !o.paused) o.pause();
    }
  }

  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('[data-llugc-card]') : null;
    if (!card || card.classList.contains('is-playing')) return;
    var v = card.querySelector('video');
    if (!v) return;
    e.preventDefault();
    pauseOthers(v);
    v.muted = false;
    v.controls = true;
    card.classList.add('is-playing');
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  });

  document.addEventListener('play', function (e) {
    var v = e.target;
    if (v && v.tagName === 'VIDEO' && !v.muted && v.closest && v.closest('[data-llugc-card]')) pauseOthers(v);
  }, true);
})();
